<template>
  <div>
    <el-form
      ref="elForm"
      :model="formData"
      :rules="rules"
      size="medium"
      label-width="100px"
    >
      <el-form-item label="子节点类型" prop="childNodeType">
        <el-radio-group v-model="formData.childNodeType" size="medium">
          <el-radio
            v-for="(item, index) in getChildNodeTypeOptions"
            :key="index"
            :label="item.value"
            :disabled="item.disabled"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="formData.childNodeType == 'normal'"
        label="子节点名称"
        prop="childNodeName"
      >
        <el-input
          v-model="formData.childNodeName"
          placeholder="请输入子节点名称"
          clearable
          :style="{ width: '100%' }"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="formData.childNodeType && formData.childNodeType != 'normal'"
        label="选择设备"
      >
        <el-transfer
          filterable
          :titles="getTransferTitles"
          v-model="transferSelectedData"
          :data="getTransferDataSrc"
        ></el-transfer>
      </el-form-item>
      <!-- <el-form-item size="large">
        <el-button type="primary" @click="submitForm" :loading="bUploading"
          >新增</el-button
        >
        <el-button @click="resetForm">重置</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import {
  queryUnbindNvr,
  queryNvrUnbindChannel,
  postAddNodes
} from '@/api/tree';

const vm = this;

export default {
  props: {
    parentId: {
      type: Number,
      default: ''
    },
    parentType: {
      type: String,
      default: 'normal'
    }
  },
  watch: {
    parentType: {
      immediate: true,
      handler(newVal, oldVal) {
        let defaultChildnNodeType = '';
        if (newVal == 'normal') {
          defaultChildnNodeType = 'normal';
        } else if (newVal == 'device') {
          defaultChildnNodeType = 'channel';
        }
        this.formData.childNodeType = defaultChildnNodeType;
      }
    },
    parentId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (this.parentType == 'normal') {
          this.handleQueryUnbindNvr();
        } else if (this.parentType == 'device') {
          this.handleQueryUnbindNvrChannel(newVal);
        }
      }
    }
  },
  data() {
    return {
      bUploading: false,
      transferSelectedData: [],
      transferOriginNvrData: [],
      transferOriginChannelData: [],
      filterMethod(query, item) {
        return item.label.includes(query) > -1;
      },
      formData: {
        childNodeType: '',
        childNodeName: ''
      },
      rules: {
        childNodeType: [
          {
            required: true,
            message: '子节点类型不能为空',
            trigger: 'change'
          }
        ],
        childNodeName: [
          {
            required: false,
            message: '请输入子节点名称',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    getChildNodeTypeOptions() {
      const arr = [
        {
          label: '区域节点',
          value: 'normal',
          disabled: this.parentType == 'device' || this.parentType == 'channel'
        },
        {
          label: 'NVR节点',
          value: 'device',
          disabled: this.parentType == 'device' || this.parentType == 'channel'
        },
        {
          label: '摄像头节点',
          value: 'channel',
          disabled: this.parentType == 'normal' || this.parentType == 'channel'
        }
      ];
      return arr;
    },
    getTransferTitles() {
      if (this.formData.childNodeType == 'device') {
        return ['待选择NVR', '已选择NVR'];
      } else if (this.formData.childNodeType == 'channel')
        return ['待选择摄像头', '已选择摄像头'];
      else return ['已选择', '待选择'];
    },
    getTransferDataSrc() {
      let arr = [];
      if (this.formData.childNodeType == 'device') {
        arr = [...this.transferOriginNvrData];
        return arr.map((d, index) => {
          return {
            key: index + '_' + d.deviceId,
            label: d.deviceName,
            disabled: d.existNode
          };
        });
      } else if (this.formData.childNodeType == 'channel') {
        arr = [...this.transferOriginChannelData];
        return arr.map((d, index) => {
          return {
            key: index + '_' + d.deviceId + '_' + d.channelId,
            label: d.channelName,
            disabled: d.existNode
          };
        });
      } else {
        return arr;
      }
    }
  },
  mounted() {
    // this.handleQueryUnbindNvr();
  },
  methods: {
    handleQueryUnbindNvr() {
      const that = this;
      queryUnbindNvr(this.$axios).then((res) => {
        const list = res.data.data.list;
        if (list && list.length > 0) {
          that.transferOriginNvrData = [...list];
        }
      });
    },
    handleQueryUnbindNvrChannel(nvrId) {
      const that = this;
      queryNvrUnbindChannel(this.$axios, nvrId).then((res) => {
        const list = res.data.data.list;
        if (list && list.length > 0) {
          that.transferOriginChannelData = [...list];
        }
      });
    },
    reloadData() {
      if (this.parentType == 'normal') {
        this.handleQueryUnbindNvr();
      } else if (this.parentType == 'device') {
        this.handleQueryUnbindNvrChannel(this.parentId);
      }
    },
    submitForm() {
      const that = this;
      this.$confirm('确认新增？')
        .then((_) => {
          this.$refs['elForm'].validate((valid) => {
            if (!valid) return;
            // TODO 提交表单
            const postData = [];
            if (that.formData.childNodeType == 'normal') {
              // 新增区域节点
              postData.push({
                parentId: that.parentId + '',
                nodeName: that.formData.childNodeName,
                nodeType: 'normal',
                deviceId: '',
                channelId: ''
              });
            } else {
              // 新增nvr或摄像头节点
              const arrSource =
                that.formData.childNodeType == 'device'
                  ? that.transferOriginNvrData
                  : that.transferOriginChannelData;
              that.transferSelectedData.forEach((d) => {
                const tmpArr = d.split('_');
                const index = tmpArr[0];
                const deviceId = tmpArr[1];
                const channelId = tmpArr[2] || '';
                const target = arrSource[index];
                if (target) {
                  const item = {
                    parentId: that.parentId + '',
                    nodeType: that.formData.childNodeType,
                    deviceId: deviceId,
                    channelId: channelId,
                    nodeName:
                      that.formData.childNodeType == 'channel'
                        ? target.channelName
                        : target.deviceName
                  };
                  postData.push(item);
                }
              });
            }
            console.log('submit postData: ', postData);

            that.bUploading = true;
            postAddNodes(this.$axios, postData)
              .then((res) => {
                console.log('postAddNodes:', res);
                if (!res.data.code) {
                  that.$message({
                    type: 'success',
                    message: '添加成功'
                  });
                  that.transferSelectedData = [];
                  that.reloadData();
                  that.formData.childNodeName = '';
                  that.$emit('refresh');
                } else {
                  that.$message({
                    type: 'error',
                    message: res.data.msg
                  });
                }
              })
              .finally(() => {
                that.bUploading = false;
                that.$emit('on-submit-finish');
              });
          });
        })
        .catch((_) => {});
    },
    resetForm() {
      this.transferSelectedData = [];
      this.$refs['elForm'].resetFields();
    }
  }
};
</script>

<style>
.el-transfer-panel {
  width: 40%;
}
</style>


// WEBPACK FOOTER //
// src/components/nodeTree/AddChildNodeForm.vue